// Browser-level messages a page script can see: Content Security Policy
// violations, plus deprecation and intervention reports (Chromium).

import { serialise, truncate } from '../../shared/serialise.js';

export function installCsp(ctx, win = window, doc = document) {
  doc.addEventListener('securitypolicyviolation', (event) => {
    try {
      if (Date.now() < ctx.cspMutedUntil) return;
      const blocked = event.blockedURI || 'inline';
      ctx.push('csp', 'error', `CSP blocked ${event.effectiveDirective}: ${truncate(blocked, 150)}`, {
        directive: event.effectiveDirective,
        violatedDirective: event.violatedDirective,
        blockedURI: event.blockedURI,
        disposition: event.disposition,
        sourceFile: event.sourceFile || undefined,
        line: event.lineNumber || undefined,
        column: event.columnNumber || undefined,
        sample: event.sample || undefined,
        policy: truncate(event.originalPolicy || '', 2000),
      });
    } catch {
      // ignore
    }
  });

  if (typeof win.ReportingObserver !== 'function') return;
  try {
    const observer = new win.ReportingObserver(
      (reports) => {
        for (const report of reports) {
          try {
            const body = report.body && typeof report.body.toJSON === 'function' ? report.body.toJSON() : report.body;
            const label = report.type === 'deprecation' ? 'Deprecation' : 'Intervention';
            const message = (body && (body.message || body.id)) || report.type;
            ctx.push('report', 'warn', `${label}: ${truncate(String(message), 200)}`, {
              type: report.type,
              url: report.url,
              body: serialise(body),
            });
          } catch {
            // ignore
          }
        }
      },
      { types: ['deprecation', 'intervention'], buffered: true },
    );
    observer.observe();
  } catch {
    // not supported
  }
}
